import { useOidc, useOidcAccessToken } from '@axa-fr/react-oidc';
import { useEffect, useRef } from 'react';

import { acquireCopilotHub, useCopilotHubStore } from 'app/modules/wallforming/components/copilot/hub/copilotHub';

const isE2EAuthBypassEnabled = import.meta.env.VITE_E2E_AUTH_BYPASS === 'true';

/** Keeps the shared copilot push connection open while the calling component is mounted. */
export const useCopilotHub = () => {
    const { isAuthenticated } = useOidc();
    const { accessToken } = useOidcAccessToken();
    const accessTokenRef = useRef<string | undefined>(accessToken);
    const enabled = isAuthenticated || isE2EAuthBypassEnabled;

    useEffect(() => {
        accessTokenRef.current = accessToken;
    }, [accessToken]);

    useEffect(() => (enabled ? acquireCopilotHub(() => accessTokenRef.current) : undefined), [enabled]);

    return useCopilotHubStore();
};
